import React, { useEffect, useState, useRef } from 'react';
interface TypewriterEffectProps {
  prompts: string[];
  typingSpeed?: number;
  deletingSpeed?: number;
  delayAfterComplete?: number;
}
export function TypewriterEffect({
  prompts,
  typingSpeed = 50,
  deletingSpeed = 30,
  delayAfterComplete = 1500
}: TypewriterEffectProps) {
  const [currentPromptIndex, setCurrentPromptIndex] = useState(0);
  const [currentText, setCurrentText] = useState('');
  const [isTyping, setIsTyping] = useState(true);
  const [isPaused, setIsPaused] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  // Clear timeout when component unmounts
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);
  useEffect(() => {
    const currentPrompt = prompts[currentPromptIndex];
    if (isPaused) {
      timeoutRef.current = setTimeout(() => {
        setIsPaused(false);
        setIsTyping(false);
      }, delayAfterComplete);
      return;
    }
    if (isTyping) {
      if (currentText.length < currentPrompt.length) {
        timeoutRef.current = setTimeout(() => {
          setCurrentText(currentPrompt.substring(0, currentText.length + 1));
        }, typingSpeed);
      } else {
        setIsPaused(true);
      }
    } else {
      if (currentText.length > 0) {
        timeoutRef.current = setTimeout(() => {
          setCurrentText(currentText.substring(0, currentText.length - 1));
        }, deletingSpeed);
      } else {
        setIsTyping(true);
        setCurrentPromptIndex(prevIndex => (prevIndex + 1) % prompts.length);
      }
    }
  }, [currentText, isTyping, isPaused, currentPromptIndex, prompts, typingSpeed, deletingSpeed, delayAfterComplete]);
  return <div className="min-h-[4rem]" data-id="element-370">
      <p className="text-black" data-id="element-371">
        {currentText}
        <span className="inline-block w-0.5 h-5 ml-0.5 bg-black animate-blink" data-id="element-372"></span>
      </p>
    </div>;
}